module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"title":"Sun Investment Group kupi gotowe projekty PV"}}')
  delete Component.options._Ctor
}
